import {createRouter, createWebHistory} from 'vue-router'
import LandingPage from "@/views/LandingPage.vue";
import ThankYouPage from "@/views/ThankYouPage.vue";
import ErrorPage from "@/views/ErrorPage.vue";

const routes = [
    {
        path: '/',
        name: 'Landing',
        component: LandingPage
    },
    {
        path: '/thank-you',
        name: 'ThankYou',
        component: ThankYouPage
    },
    {
        path: '/error',
        name: 'Error',
        component: ErrorPage
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
